var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.226,
    height: 20.185,
    viewBox: "0 0 26.226 20.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3486",
    "data-name": "Groupe 3486",
    transform: "translate(-13171.043 3697.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3180",
    "data-name": "Groupe 3180",
    transform: "translate(13171.043 -3697.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3179",
    "data-name": "Groupe 3179",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3178",
    "data-name": "Groupe 3178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3177",
    "data-name": "Groupe 3177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2009",
    "data-name": "Trac\\xE9 2009",
    d: "M-51.846,2742.649a2.373,2.373,0,0,1-2.374-2.371v-4.286a8.575,8.575,0,0,0-6.457-8.508,8.46,8.46,0,0,0-7.143,1.634,8.326,8.326,0,0,0-3.131,6.512v4.647a2.373,2.373,0,0,1-2.374,2.371,2.372,2.372,0,0,1-2.374-2.371v-4.647a13.044,13.044,0,0,1,4.9-10.207,13.193,13.193,0,0,1,11.133-2.573,13.343,13.343,0,0,1,10.191,13.141v4.286A2.372,2.372,0,0,1-51.846,2742.649Z",
    transform: "translate(75.698 -2722.536)",
    fill: "#b9b9b9"
  }))))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(13181.656 -3682.751)",
    fill: "#b9b9b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/mediaIcon.9241cbb04b441e2a286b3772c65d7746.svg";
export { ForwardRef as ReactComponent };